module.exports = __webpack_public_path__ + "img/arrow-top.a0c9261e.svg";